/*
Source for Withings 'appli' values : https://developer.withings.com/developer-guide/v3/data-api/keep-user-data-up-to-date/
Each appli represents a measurement group -> meastypes are subvalues of these groups
*/

const MEASUREMENT_GROUPS = {
  1: 'Weight',
  4: 'Blood Pressure',
};

const WITHINGS_DEVICES = {
  BP: 'BLOOD PRESSURE CUFF', // Do Not Use, BP value is deprecated in favor of BLOOD_PRESSURE_MONITOR
  BLOOD_PRESSURE_MONITOR: 'BLOOD PRESSURE MONITOR',
  SCALE: 'SCALE',
  KIT: 'KIT',
  BP_CUFF_XL: 'BP_CUFF_XL',
};

const WITHINGS_SIGNED_OFF_ORDER_STATUS = {
  VERIFIED: 'VERIFIED',
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED',
  ERROR: 'ERROR',
};
const WITHINGS_DEVICE_STATUS = {
  LINKED: 'LINKED',
  UNLINKED: 'UNLINKED',
};
const WITHINGS_SIM_STATUS = {
  ACTIVE: 'ACTIVE',
  TERMINATED: 'TERMINATED',
};

const WITHINGS_KIT = {
  [WITHINGS_DEVICES.SCALE]: WITHINGS_DEVICES.BLOOD_PRESSURE_MONITOR,
  [WITHINGS_DEVICES.BLOOD_PRESSURE_MONITOR]: WITHINGS_DEVICES.SCALE,
};

const ATHENA_SCALE = 'BODY WEIGHT SCALE';
const ATHENA_BP = 'BLOOD PRESSURE CUFF';

const ATHENA_WITHINGS_DEVICE_MAP = {
  [ATHENA_SCALE]: WITHINGS_DEVICES.SCALE,
  [ATHENA_BP]: WITHINGS_DEVICES.BLOOD_PRESSURE_MONITOR,
};

const WITHINGS_DEVICE_MAP = {
  'BPM Connect Pro': WITHINGS_DEVICES.BLOOD_PRESSURE_MONITOR, // Legacy product, has been replaced with BPM Pro 2
  'BPM Pro 2': WITHINGS_DEVICES.BLOOD_PRESSURE_MONITOR,
  'Body Pro': WITHINGS_DEVICES.SCALE,
};

module.exports = {
  ATHENA_WITHINGS_DEVICE_MAP,
  MEASUREMENT_GROUPS,
  WITHINGS_DEVICES,
  WITHINGS_KIT,
  WITHINGS_SIGNED_OFF_ORDER_STATUS,
  WITHINGS_SIM_STATUS,
  WITHINGS_DEVICE_MAP,
  WITHINGS_DEVICE_STATUS,
};
